<template>
    <PopularizeLaw ref="pageWrapper"></PopularizeLaw>
</template>

<script>
import COVER from "@/utils/COVER";
import { mapState, mapActions, mapMutations } from "vuex";
import PopularizeLaw from "@/components/PopularizeLaw";
import { objBlurFun } from "@/utils/utils";

export default {
    name: "home",
    data() {
        return {
            initTimer: null
        };
    },
    components: {
        PopularizeLaw,
    },
    computed: {
        ...mapState(["isApp", "topicData", "userinfo", "maskData", "serverTime", "pageLoading", "isImmerse", "shareData", "versionSize", "homeChat", "readNewsId", "isClearInitTimer", "device", "robotConfig"])
    },
    created() {
    },
    watch: {

        homeChat(val) {

        },

        isClearInitTimer: {
            handler(value, o) {
                if (value) {
                    clearInterval(this.initTimer);
                } else {
                    // this.initTimer = this.getInterData();
                }
            },
            deep: true
        },

        $route(to, from) {
            console.log('路由变化了');
            console.log('当前页面路由：' + to.path);
            console.log('上一个路由：' + from.path);

            if (to.path == '/') {
                window.location.reload();
            }
        }

    },
    mounted() {
        // this.getInterData();
        this.share();
        document.body.className = "home-body";
        // document.querySelector(".loading-wrap").style.display = "none";
        this.setPageLoadingAsync(false);
        objBlurFun(this.device, "input");

        // this.queryTourism()
    },
    destroyed() {
        this.setHomeData([]);
        clearTimeout(this.initTimer);
    },
    methods: {
        ...mapMutations([
            "contactDisData", "setHomeData", "setClearTimer", "contactDisData", "chatDisData"
        ]),
        ...mapActions([
            "setMaskDataAsync",
            "getUserInfoAsync",
            "setPageLoadingAsync",
            "fetchHome",
            "fetchNotice",
            "setNoInfo",
            "queryTourism",
            "getRobotConfig",
        ]),

        share() {
            // this.getRobotConfig().then(res => {
            //     let ShareData = JSON.parse(JSON.stringify({...this.shareData, ...this.robotConfig.shareInfo}));
            //     ShareData.callback = function (ret) {
            //         console.log('ret---');
            //         console.log(ret);
            //     };
            //     COVER.share(ShareData);
            // })

            COVER.share(this.shareData);
        },
        getInterData() {
            let that = this;
            this.initTimer = setTimeout(function () {
                that.setNoInfo();
            }, 5000);
        },
        onPagePoke() {
            this.$refs.pageWrapper.onPoke();
        }
    }
};
</script>

<style lang="less">
.chatList-item {
    display: inline-block;
    margin-right: 10px;
}

/*.chatList-enter-active,*/
/*.chatList-leave-active {*/
/*    transition: all 1s;*/
/*}*/
.chatList-enter-active {
    transition: all .4s;
}

.chatList-leave-active {
    transition: all 0s;
}

.chatList-enter,
.chatList-leave-to {
    /*opacity: 0;*/
    transform: translateX(50px);
}
</style>
